import {
  ITripResponseType,
  LatestWorkerMovement,
} from "../containers/facilityDashboard/ShiftCalendar/dayView/workerETA/types";
import { WORKER_ETA_DISTANCE_TOLERANCE } from "../containers/facilityDashboard/ShiftCalendar/dayView/facilityShiftCard/constants";

export function determineIsWorkerAtHome(
  trip: Pick<
    ITripResponseType,
    "latestWorkerMovement" | "initialEtaDistance" | "currentEtaDistance"
  >
): boolean {
  return (
    trip.latestWorkerMovement === LatestWorkerMovement.STATIONARY &&
    Math.abs(trip.initialEtaDistance - trip.currentEtaDistance) <= WORKER_ETA_DISTANCE_TOLERANCE
  );
}
